var collapsibleStyleObject = {
  "collapsible": {
    "cursor": "pointer",
    "padding": "15px 20px",
    "textAlign": "left",
    "transition": "background-color 0.25S ease-in-out",
    "width": "100%",
    "wordWrap": "break-word",
    "wordBreak": "break-word",
    "overflowWrap": "anywhere",
    "&:hover:not(.expandableLink)": {
      "backgroundColor": "rgba(151, 153, 155, 0.08)"
    },
    "&:focus": {
      "outline": "dashed 1px #53565a",
      "outlineOffset": "3px"
    }
  },
  "collapsible__icon": {
    "color": "#006fcf"
  },
  "collapsibleCaret": {
    "color": "#53565a",
    "paddingRight": "10px",
    "verticalAlign": "text-top",
    "display": "inline-flex",
    "flexShrink": "0",
    "&::before": {
      "fontFamily": "\"dls-icons-2.25.0\"",
      "content": "\"\"",
      "lineHeight": "1.375rem",
      "WebkitFontSmoothing": "antialiased",
      "MozOsxFontSmoothing": "grayscale",
      "fontSize": "1rem",
      "display": "inline-block",
      "position": "relative",
      "transform": "rotate(0deg)",
      "transition": "color 0.25S ease-out, transform 0.25S ease-out"
    }
  },
  "collapsible_aria_expanded_true": {
    "color": "#00175a"
  },
  "collapsible_aria_expanded_true___icon": {
    "color": "#00175a"
  },
  "collapsible_aria_expanded_true___collapsibleCaret": {
    "&::before": {
      "transform": "rotate(90deg)"
    }
  },
  "collapsible_all_children": {
    "&:last-child": {
      "flexBasis": "100%"
    }
  },
  "collapsible_expandableLink": {
    "color": "#333",
    "&:hover": {
      "cursor": "auto"
    }
  },
  "accordionContent": {
    "margin": "0",
    "overflow": "hidden",
    "transition": "max-height 0.4S ease-out"
  },
  "toggleLink": {
    "color": "#006fcf",
    "&:hover": {
      "textDecoration": "underline"
    }
  },
  "button_collapsible": {
    "display": "inline-flex",
    "alignItems": "flex-start"
  },
  "button_collapsible_all_children": {
    "pointerEvents": "none"
  }
};

export default collapsibleStyleObject;
